import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';

import './index.sass';

const { block } = bem('memberships');

const Membership = ({ full, short }) => {
    let text;
    if (full && !short) {
        text = full;
    } else if (!full && short) {
        text = short;
    } else {
        text = `${ full } (${ short })`;
    }
    return <Text tag={'div'}>{ text }</Text>
}

const Memberships = ({ memberships }) => {
    return (
        <div className={ block() }>
            { memberships.map(({ full, short }, i) => <Membership key={ i } full={ full } short={ short }/>) }
        </div>
    )
};

export default Memberships;
